import React from "react";
import { Row } from "antd";
import ListaFotos from "./ListaFotos";

export const FotosServicio = () => {
  return (
    <>
      <Row style={{ marginTop: 20 }}>
        <ListaFotos />
      </Row>
    </>
  );
};
